<template>
  <div id="app">
    <!--
      This section displays the main site.
      It is hidden when legal notices are displayed.
    -->
    <div v-if="!showLegalNotice">
      <Navbar />
      <main>
        <HeroSection />
        <AboutUs id="qui-sommes-nous" />
        <ContactLocation id="ou-sommes-nous" />
        <PreInscription id="formulaire" />
      </main>
      <!--
        We listen for the "show-legal" event emitted by the Footer.
        When received, we set the showLegalNotice variable to true.
      -->
      <Footer @show-legal="showLegalNotice = true" />
    </div>

    <!--
      This section displays the legal notices page.
      It is only visible if showLegalNotice is true.
      It listens for the "close" event to hide itself.
    -->
    <LegalNotice v-if="showLegalNotice" @close="showLegalNotice = false" />
  </div>
</template>

<script setup lang="ts">
// We import all components for our page
import Navbar from "@/components/Navbar.vue";
import HeroSection from "@/components/HeroSection.vue";
import AboutUs from "@/components/AboutUs.vue";
import ContactLocation from "@/components/ContactLocation.vue";
import PreInscription from "@/components/PreInscription.vue";
import Footer from "@/components/Footer.vue";
import LegalNotice from "@/components/LegalNotice.vue";
import { ref } from "vue";

const showLegalNotice = ref(false);
</script>

<style lang="scss">
// Global styles for a nice appearance
#app {
  font-family: 'Nunito', sans-serif; // Softer and more modern font
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333; // A softer black than #2c3e50
  text-align: center;
}

// Ensures smooth scrolling when clicking menu links
html {
  scroll-behavior: smooth;
}

// Adds some space between sections to space out the design
main > section {
  padding-top: 5rem;
  padding-bottom: 5rem;
}

// The Contact/Location section often has a colored background, we adjust the padding
#ou-sommes-nous {
  padding-top: 4rem;
  padding-bottom: 4rem;
}

// In App.vue, inside <style lang="scss">

// We define our color variables from the logo
:root {
  /* Water green from logo as primary color */
  --bs-primary: #66cdaa;
  --bs-primary-rgb: 102, 205, 170;

  /* Pink from logo as accent color */
  --bs-secondary: #f8b5d5;
  --bs-secondary-rgb: 248, 181, 213;
}

// We can also improve button styles across the site
.btn-primary {
  background-color: var(--bs-primary);
  border-color: var(--bs-primary);
  font-weight: 500;
  transition: all 0.2s ease-in-out;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(var(--bs-primary-rgb), 0.3);
}


</style>
